<div class="dropdown">
    <button class="btn primary-white-button dropdown-toggle dropdownButton" type="button" id="dropdownMenuButton"
        (click)="toggleDropdown()" #dropdownContainer>
        {{ label }}
        <img *ngIf="image" [src]="image" alt="icon" class="ml-2">
    </button>
    <div class="dropdown-menu" (click)="$event.stopPropagation()"
        [@dropdownAnimation]="isDropdownOpen ? 'open' : 'closed'" [class.show]="isDropdownOpen"
        aria-labelledby="dropdownMenuButton">
        <ng-content></ng-content>
    </div>
</div>